import { Component } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { IPaymentsBasketView } from './paywith/basket-view-paywith.component';

export namespace NBasketViewCms {
    export const BLOCK_ID = 'cms-basket-view';

    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;

    export interface IBlockDataContent {
        /**
         * Bottom components list
         */
        bottomComponents: NICmsContentComponent.IData[];
        /**
         * Components for empty state
         */
        emptyComponents: NICmsContentComponent.IData[];
        /**
         * Empty basket copy
         */
        emptyCopy: string;
        /**
         * Empty basket button copy
         */
        emptyCtaCopy: string;
        /**
         * Avalible payments
         */
        payments?: IPaymentsBasketView[];
        /**
         * Reviews image
         */
        reviewsImage?: string;
        /**
         * Reviews link
         */
        reviewsLink?: string;
    }
}

/**
 * Component definition
 */
@Component({
    selector: 'basket-view-cms',
    template: '@if (content) {<basket-view [content]="content"></basket-view>}'
})
@ICmsComponent<BasketViewCmsComponent>({
    id: NBasketViewCms.BLOCK_ID,
    block: {
        url: NBasketViewCms.BLOCK_ID
    },
    onDemandOnly: true,
    name: 'Basket page layout',
    description: 'Basket page layout block',
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-specification',
            title: 'Side area'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-bottom',
            title: 'Bottom part'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'payments',
            title: 'Payments',
            itemName: 'Payment Option',
            itemNameField: 'name',
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'name',
                    title: 'Payment name'
                },
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'icon',
                    title: 'Payment icon'
                }
            ]
        },
        <NICmsContentField.IComponentsField>{
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Bottom components',
            itemName: 'component',
            default: []
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'label-empty',
            title: 'Empty basket'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'emptyCopy',
            title: 'Empty basket heading copy',
            default: 'Your bag is empty',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'emptyCtaCopy',
            title: 'Empty basket continue button copy',
            default: 'Continue shopping',
            required: true
        },
        <NICmsContentField.IComponentsField>{
            key: 'emptyComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Empty basket components',
            itemName: 'component',
            default: []
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.image,
            key: 'reviewsImage',
            title: 'Reviews image'
        },
        <NICmsContentField.ITextField>{
            type: NICmsContentField.EFieldType.text,
            key: 'reviewsLink',
            title: 'Reviews link',
            default: '/reviews'
        }
    ]
})
export class BasketViewCmsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NBasketViewCms.IBlockDataContent;

    protected override canDetach = false;
}
